import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status?: ReduxStateType;
  formData: {
    note: string;
  };
}

const initialState: InitialState = {
  status: ReduxStateType.INIT,
  formData: {
    note: "",
  },
};

const rejectRecruitmentRequirementSlice = createSlice({
  name: "rejectRecruitmentRequirement",
  initialState,
  reducers: {
    updateFormRejectRecruitment: (state, action) => {
      state.formData = {
        ...state.formData,
        ...action.payload,
      };
    },

    rejectRecruitmentRequirementStart: (
      state,
      action: PayloadAction<{ id: string; note: string }>
    ) => {
      state.status = ReduxStateType.LOADING;
    },
    rejectRecruitmentRequirementSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    rejectRecruitmentRequirementFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  updateFormRejectRecruitment,
  rejectRecruitmentRequirementStart,
  rejectRecruitmentRequirementSuccess,
  rejectRecruitmentRequirementFailed,
} = rejectRecruitmentRequirementSlice.actions;

export default rejectRecruitmentRequirementSlice.reducer;
